<template>
  <div>
    <template v-if="isLoading">
      <div class="skeleton skeleton-input" :style="skeletonStyle"></div>
    </template>

    <template v-else-if="error">
      <div class="d-flex" style="gap: 8px; flex-wrap: wrap;">
        <p class="text-danger mb-2">{{ errorMessage }}</p>
        <b-button size="sm" variant="outline-danger" @click="$emit('retry')">
          Coba Lagi
        </b-button>
      </div>
    </template>

    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: "StateInputHandler",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: "Gagal memuat data.",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    skeletonStyle() {
      return {
        maxWidth: this.fullWidth ? "100%" : "350px",
      };
    },
  }
};
</script>
